import { fetchCountElemReq } from './fetchElementRequirementsCountThunk';
export default fetchCountElemReq;
